<template>
  <a :href="getBookingRouteUrl(RouteNames.Login)" class="login-link"><span
      class="icon icon--captain login-link__icon"/>{{ translations['bookings.header.login'] }}</a>
</template>

<script setup lang="ts">
import {getBookingRouteUrl} from "@services/booking-route-service";
import { RouteNames } from "@services/booking-route-service";
import {getTranslations} from "@shared/Services/translations";

const translations = getTranslations();

</script>
